import { DEFAULTS } from "./defaults.js";
import { INDENT_TYPE } from "./types.js";
const pluginIndent = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: INDENT_TYPE
  };
};
export {
  pluginIndent
};
//# sourceMappingURL=viewer.js.map
